export const getRetailInvestValue = (state) => state.filters.retail.investValue;
export const getRetailBusinessSearch = (state) => state.filters.retail.businessSearch;
export const getRetailBusinessDisplayMode = (state) => state.filters.retail.businessDisplayMode;
export const getSelfBusinessSearch = (state) => state.filters.self.businessSearch;
export const getPromBusinessSearch = (state) => state.filters.prom.businessSearch;
export const getPromBusinessDisplayMode = (state) => state.filters.prom.businessDisplayMode;
export const getUpdatedLocationParams = (state) => state.filters.updatedLocationParams;
export const getLocationsCompareParams = (state) => state.filters.locationsCompareParams;
export const getAreaCompareParams = (state) => state.filters.areaCompareParams;
